/** @type {import('../types').ProgramConfig} */
export default {
  code: 'POC',
  displayName: 'Proof of Concept',
  shortName: 'POC',
  color: 'grey',
  statusLabels: {
    recommend_approval: 'Recommend Approval',
    recommend_rejection: 'Recommend Rejection',
    needs_review: 'Needs Review',
  },
  sidebarItems: [],
  listColumns: [],

  feedback: {
    enabled: true,
    validations: [
      { key: 'approval_history',
        label: '1. Approval History (SOP Section 2, Step 2 — claim submitted/reassigned)',
        keywords: ['approval history', 'approval_history', 'claim submitted'] },
      { key: 'partner_exception',
        label: '2. Partner Exception Check (SOP Section 2, Step 3 — active hold/exception)',
        keywords: ['partner exception', 'partner_exception', 'hold', 'exception'] },
      { key: 'po_4j_check',
        label: '3. 4J PO — AWS India Approval (SOP Section 2, Step 4 — Phonetool India residency)',
        keywords: ['4j', 'aispl', 'india', 'po_4j', 'phonetool'] },
      { key: 'cst_validation',
        label: '4. Customer Sign-off Template (version, integrity, fields, acknowledgements, signature)',
        keywords: ['cst', 'customer sign-off', 'customer_sign_off', 'signature', 'acknowledgement'] },
      { key: 'cst_wwps_amount',
        label: '5. CST Public Sector Funding Amount (Total AWS Pre-approved Funding Amount)',
        keywords: ['wwps', 'public sector', 'pre-approved funding', 'cstnowwps'] },
      { key: 'claim_amount',
        label: '6. Claim Amount Accuracy (claim vs CST-approved amount)',
        keywords: ['claim amount', 'claim_amount', 'amount mismatch'] },
    ],
    decisionOptions: [
      { value: 'recommend_approval',  label: 'Recommend Approval' },
      { value: 'recommend_rejection', label: 'Recommend Rejection' },
      { value: 'needs_review',        label: 'Needs Review' },
    ],
  },
};
